import React, {Suspense, lazy} from 'react';
import {loginLoader} from '../../loader';
import {ROUTE_FORGOT_PASSWORD, ROUTE_LOGIN, ROUTE_OAUTH2_LOGIN_WITH_PARAMS} from '../../RoutePathConstant';
import {Spin} from 'antd';

const Login = lazy(() =>
  import('../../../screens/Login')
    .then(module => ({default: module.Login})));

const ForgotPassword = lazy(() =>
  import('../../../screens/Login')
    .then(module => ({default: module.ForgotPassword})));

const Oauth2Login = lazy(() =>
  import('../../../screens/Login')
    .then(module => ({default: module.Oauth2Login})));

const LoginNavigation = [
  {
    path: ROUTE_LOGIN,
    element: (
      <Suspense fallback={<Spin />}>
        <Login />
      </Suspense>
    ),
    loader: loginLoader,
  },
  {
    path: ROUTE_FORGOT_PASSWORD,
    element: (
      <Suspense fallback={<Spin />}>
        <ForgotPassword />
      </Suspense>
    ),
    loader: loginLoader,
  },
  {
    path: ROUTE_OAUTH2_LOGIN_WITH_PARAMS,
    element: (
      <Suspense fallback={<Spin />}>
        <Oauth2Login />
      </Suspense>
    ),
  },
];

export default LoginNavigation;
